import { PartTypeSchema, PartTypeType } from "../types";

export const isMachiningPartType = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return false;
  }

  switch (partType) {
    case PartTypeSchema.enum.MACHINING:
      return true;
    case PartTypeSchema.enum.ROUND_TUBE:
      return true;
    case PartTypeSchema.enum.SQUARE_TUBE:
      return true;
    case PartTypeSchema.enum.RECTANGULAR_TUBE:
      return true;
    case PartTypeSchema.enum.ROUND_BAR:
      return true;
    case PartTypeSchema.enum.SQUARE_BAR:
      return true;
    default:
      return false;
  }
};
